<template>
  <b-container class="pl-0 pr-0 pt-0 pb-0">
    <b-row v-if="loading">
      <b-col>
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-col>
    </b-row>
    <b-row v-show="!loading && hideNewField">
      <b-col class="text-left">
        <b-form-group 
          id="customerGroupe"
          breakpoint="md"
          label="Customer"
          label-for="customerselect"
          :horizontal="horizontal"
          validated
        >
          <b-form-select v-model="selected_customer" :options="customers" class="mb-3" id="customerselect" @input="selectionMade($event)" v-on:change="selectionMade($event)" required/>    
        </b-form-group>
      </b-col>
    </b-row>        
    <b-row v-if="!noNew && !selected_customer && hideNewField">
      <b-col class="text-left">
        <b-button variant="primary" @click="addNew()">Add New</b-button>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false">
      <b-col class="text-left">
        <b-form-group 
          id="namegroup"
          breakpoint="md"
          label="Customer Name"
          label-for="customername"
          :horizontal="horizontal"
          validated
        >
          <b-form-input maxlength="255" v-model="newCustomer.name" placeholder="New Customer Name" required/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && newCustomer.name">
      <b-col class="text-left">
        <b-form-group 
          id="industrygroup"
          breakpoint="md"
          label="Industry"
          label-for="customerindustry"
          :horizontal="horizontal"
          validated
        >
          <b-form-select v-model="newCustomer.industry" :options="industries" class="mb-3" id="customerindustry" required/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && newCustomer.industry">
      <b-col class="text-left">
        <b-form-group 
          id="industry2group"
          breakpoint="md"
          label="Secondary Industry"
          label-for="customerindustry2"
          :horizontal="horizontal"
          validated
        >
          <b-form-select v-model="newCustomer.secondary_industry" :options="industries" class="mb-3" id="customerindustry2"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && newCustomer.industry">
      <b-col class="text-left">
        <b-form-group 
          id="countrygroup"
          breakpoint="md"
          label="Country"
          label-for="customercountry"
          :horizontal="horizontal"
          validated
        >
          <b-form-select v-model="newCustomer.country" :options="countries" class="mb-3" id="customercountry" required/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="hideNewField === false && newCustomer.country">
      <b-col class="text-left">
        <b-form-group 
          id="regiongroup"
          breakpoint="md"
          label="Region"
          label-for="customerregion"
          :horizontal="horizontal"
          validated
        >
          <b-form-select v-model="newCustomer.region" :options="regions" class="mb-3" id="customerregion"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="!hideNewField && !loading && !noNew">
      <b-col class="text-left">
        <b-button variant="success" @click="save()" :disabled="!newCustomer.country">Save</b-button>
      </b-col>
      <b-col class="text-right">
        <b-button variant="default" @click="cancelAdd()">Cancel</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import * as API from '@/services/API'
import {industries, countries, getRegions} from '@/services/constants';

export default {
    name: 'CustomerSelection',
    // properties you can pass to this component
    props: {
        customer: {
            default: null,
            type: Number
        },
        noNew: false,
        horizontal: false
    },
    watch: {
      newCustomer: {
        handler(newData) {
          if (newData && newData.country) this.regions = this.getRegions(newData.country);
        },
        deep: true
      },
      customer: {
        handler(newData) {
          if (newData) this.selected_customer = newData;
        }
      }
    },
    // this is reactive data and will be updated in the view
    data () {
        return {
            customers: [],
            pagination: {
                totalRecords: 1,
                totalPages: 1,
                page: 1,
                pageSize: 1
            },
            hideNewField: true,            
            newCustomer: {
              name: '',
              industry: '',
              secondary_industry: '',
              country: '',
              region: ''
            },
            selected_customer: this.customer || null,
            loading: false,
            industries,
            countries,
            regions: [],
            getRegions
        }
    },
    created () {
        this.fetchData();
    },
    methods: {
        fetchData () {
          this.loading = true
          var token = this.$root.token + '';
          return API.getCustomers(token).then(res => {
            // convert data to something our dropdown can work it
            this.customers = [ { value: null, text: 'Select a customer or Add New....' } ]
            .concat(
              res.results.map(i => {
                return {
                  value: i.id,
                  text: i.name
                }
              }) 
            )
            this.pagination = res.pagination
            this.loading = false
          })
        },
        addNew () {
          this.hideNewField = false
          this.newCustomerName = ''
        },
        cancelAdd () {
          this.hideNewField = true
          this.newCustomerName = ''
        },
        save () {
            if(this.newCustomer.name !== '') {
              return API.addCustomer(this.newCustomer,this.$root.token).then(response => {
                // success callback
                return this.fetchData().then(() => {
                  this.hideNewField = true
                  this.selected_customer = response.body.id
                })
              })
            }
        },
        selectionMade (e) {
          this.$emit('update:customer', this.selected_customer)
        }
    }
    
}
</script>

/* 
    "results": [
        {
            id: 1,
            name: "Company-X"
        }
    ],
    "pagination": {
        "totalRecords": 1,
        "totalPages": 1,
        "page": 1,
        "pageSize": 1
    }
}
*/



// WEBPACK FOOTER //
// src/components/CustomerSelection.vue